import styled from '@happymoneyinc/styled-components';
import PropTypes from 'prop-types';
import { meta } from '@happymoneyinc/meta';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import SvgIcon from '../SvgIcon/SvgIcon.js';
import Paragraph from '../Paragraph/Paragraph.js';

const Checkbox = props => {
  const {
    ariaLabel,
    className,
    checked,
    disabled,
    id,
    onFocus,
    labelText,
    onChange,
    onClick,
    testID
  } = props;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsxs(Label, {
      className: className,
      disabled: disabled,
      htmlFor: id,
      children: [/*#__PURE__*/jsx(HiddenCheckbox, {
        "aria-checked": checked,
        "aria-label": ariaLabel || labelText,
        checked: checked,
        "data-testid": testID,
        disabled: disabled,
        id: id,
        onChange: onChange,
        onFocus: onFocus,
        onClick: onClick,
        tabindex: "0",
        type: "checkbox"
      }), /*#__PURE__*/jsx(FocusBorder, {
        children: /*#__PURE__*/jsx(StyledSvg, {
          "aria-hidden": "true",
          checked: checked,
          disabled: disabled,
          fill: checked ? meta.colors.white : 'none',
          focusable: "false",
          height: "12",
          type: "checkmarkNew",
          width: "12"
        })
      }), !!labelText && /*#__PURE__*/jsx(StyledP, {
        muted: disabled,
        children: labelText
      })]
    })
  });
};
const Label = styled.label`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  pointer-events: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 'none' : 'auto';
}};
  position: relative;
`;
const StyledSvg = styled(SvgIcon)`
  background-color: ${_ref2 => {
  let {
    checked,
    disabled,
    theme
  } = _ref2;
  if (checked && !disabled) return theme.colors.flamingo[1];
  if (checked && disabled) return theme.colors.gray[4];
  return 'none';
}};
  border-radius: 4px;
  border: ${_ref3 => {
  let {
    disabled,
    theme
  } = _ref3;
  return disabled ? `2px solid ${theme.colors.gray[3]}` : `2px solid ${theme.colors.black}`;
}};
  box-sizing: content-box;
  padding: 6px;
  position: relative;
  transition: all 0.1s linear;
`;
const FocusBorder = styled.div`
  position: relative;

  ::before {
    border-radius: 8px;
    border: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return `1px dashed ${theme.colors.flamingo[1]}`;
}};
    bottom: 0;
    box-sizing: content-box;
    content: '';
    display: block;
    height: 26px;
    left: -4px;
    opacity: 0;
    padding: 4px;
    position: absolute;
    right: 0;
    top: -4px;
    width: 26px;
  }
`;
const HiddenCheckbox = styled.input`
  box-sizing: content-box;
  height: 24px;
  opacity: 0;
  position: absolute;
  width: 24px;

  :focus + ${FocusBorder} {
    ::before {
      opacity: 1;
    }
  }
`;
const StyledP = styled(Paragraph)`
  margin-left: 10px;
`;
Checkbox.defaultProps = {
  ariaLabel: '',
  checked: false,
  className: '',
  disabled: false,
  id: '',
  labelText: '',
  onChange: null,
  onClick: null,
  onFocus: null,
  testID: 'checkbox'
};
Checkbox.propTypes = {
  ariaLabel: PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  labelText: PropTypes.node,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  testID: PropTypes.string
};
var Checkbox$1 = Checkbox;

export { Checkbox$1 as default };
//# sourceMappingURL=Checkbox.js.map
